module.exports = __webpack_public_path__ + "static/media/pic1.c4c02d9c.webp";